import React, { useState, useCallback } from "react";
import HoverHandler from "./HoverHandler";

const HighlightText = React.memo(({ summary }) => {
  const text = summary;

  const highlightedWords = {
    "prime cost":
      "A prime cost is the total direct costs of production, including raw materials and packaging materials",
    "cost center":
      "A cost centre is a department within a business to which costs can be allocated",
    "profit center":
      "A profit center is a department or division of a company that generates revenue and profits, and is treated as a separate business unit",
    "prime margin": "Affiliate Sales + GSV Third Party - Trade-Prime Cost",
    "confidence interval":
      "A 95% confidence interval for the standard normal distribution",
  };


  const renderText = useCallback(
    ({ handleMouseEnter, handleMouseLeave }) => {
      let processedText = text; // Copy of the original text
      const elements = [];
      const words = Object.keys(highlightedWords); // Get all the words/phrases to highlight

      // Sort by length to ensure we match longer phrases first
      words.sort((a, b) => b.length - a.length);

      let matchIndex = 0;

      // Process each word in the highlightedWords list
      words.forEach((word) => {
        // Regular expression to match exact word boundaries and allow trailing 's'
        const regex = new RegExp(`\\b(${word})(s)?\\b`, "gi");
        let result;

        while ((result = regex.exec(processedText)) !== null) {
          // Add the text before the match as a normal span
          if (matchIndex < result.index) {
            elements.push(
              <span key={matchIndex}>{processedText.slice(matchIndex, result.index)}</span>
            );
          }

          // Highlight the matched word or phrase
          const originalMatchedText = result[1]; // Base word (without 's')

          // Check if the match ends with 's' and remove it from the highlighted part
          const hasTrailingS = !!result[2];

          elements.push(
            <span
              key={result.index}
              style={{
                color: "#1453A0",
                textDecoration: "underline",
                cursor: "pointer",
                marginRight: hasTrailingS ? "0" : "5px", // Adjust margin after the word
              }}
              onMouseEnter={(event) => handleMouseEnter(event, word)}
              onMouseLeave={handleMouseLeave}
            >
              {originalMatchedText}
            </span>
          );

          // If there's a trailing 's', add it separately as non-highlighted text
          if (hasTrailingS) {
            elements.push(
              <span key={`${result.index}-s`} style={{ marginRight: "5px" }}>
                s
              </span>
            );
          }

          // Update matchIndex to continue from the end of the matched word/phrase
          matchIndex = result.index + originalMatchedText.length + (hasTrailingS ? 1 : 0);
        }
      });

      // Add any remaining text after the last match
      if (matchIndex < processedText.length) {
        elements.push(
          <span key={matchIndex}>{processedText.slice(matchIndex)}</span>
        );
      }

      return elements;
    },
    [highlightedWords]
  );


  return (
    <HoverHandler highlightedWords={highlightedWords}>
      {({ handleMouseEnter, handleMouseLeave }) => (
        <div style={{ position: "relative" }}>
          <p>{renderText({ handleMouseEnter, handleMouseLeave })}</p>
        </div>
      )}
    </HoverHandler>
  );
});

export default HighlightText;
